module.exports = __webpack_public_path__ + "img/svg/facebook-cd0f4ba2.svg";